import React from 'react';
import {connect} from "react-redux";
import {AppState} from "@Redux/store";
import Repeater from "@Utils/Repeater";

const ArmyListPrivate: React.FC<ArmyListPrivateProps> = ({
                                                           isLoading,
                                                           isPrivate,
                                                           currentEvents,
                                                           closedEvents
                                                         }) => {
  if (isLoading || !isPrivate) return (<div/>);

  return <div className="border-red">
    <h3>Warning !!!</h3>
    <p>This list is private or used for a tournament.</p>
    <p>It's impossible for others users to see this list. Only you, your team or tournament organisator can see this
      list.</p>
    <Repeater data={currentEvents} indexPrefix='event'>
      {
        (item: any) => <div>
          <p>It will be impossible for you to update this army list after {item.limitDate} for
            the {item.name} Tournament.</p>
          <p>The limit for the list is {item.armyListMax}.</p>
        </div>
      }
    </Repeater>
    <Repeater data={closedEvents} indexPrefix='event'>
      {
        (item: string) => <div>
          <p>It's impossible for you to update this army list. It's used for the {item} Tournament.</p>
          <p>You can clone this army list if you want use it again.</p>
        </div>
      }
    </Repeater>
  </div>;
};

const mapStateToProps = (state: AppState) => ({
  isLoading: state.armyList.isLoading,
  isPrivate: state.armyList.entity?.isPrivate ?? false,
  currentEvents: new Array<any>(),
  closedEvents: new Array<any>(),
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ArmyListPrivate);

type ArmyListPrivateProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>